export type EmailFieldBehavior = "required" | "optional" | "hidden";

export const VALID_EMAIL_FIELD_BEHAVIOR = ["required", "optional", "hidden"] as const satisfies EmailFieldBehavior[];

export const convertStringToEmailFieldBehavior = (str: string): EmailFieldBehavior | undefined =>
  VALID_EMAIL_FIELD_BEHAVIOR.find((reason) => reason === str);
